module.exports = __webpack_public_path__ + "img/ribbon-sm.62f2b473.svg";